const configuredApiUrl = process.env.REACT_APP_API_URL;
if (!configuredApiUrl) {
  throw new Error("Set REACT_APP_API_URL in the selected client .env file.");
}

export const API_URL = configuredApiUrl.replace(/\/+$/, "");
export const apiUrl = (path: string) =>
  `${API_URL}/${path.replace(/^\/+/, "")}`;
